import { render, staticRenderFns } from "./FeedbackAIAssistant.vue?vue&type=template&id=2eaa7b5a"
import script from "./FeedbackAIAssistant.vue?vue&type=script&lang=js"
export * from "./FeedbackAIAssistant.vue?vue&type=script&lang=js"
import style0 from "./FeedbackAIAssistant.vue?vue&type=style&index=0&id=2eaa7b5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports